export const FEATURE_FLAGS = Object.freeze({
  /**
   * ZUORA_CHECKOUT
   *
   * When enabled, the subscription checkout page should use the Zuora gateway instead of Stripe
   */
  ZUORA_CHECKOUT: 'zuora_checkout',

  /**
   * MIGRATION_ACCOUNT_LOCK
   *
   * When enabled, users with subscriptions on the Stripe gateway should:
   *   - be blocked from performing any subscription-altering actions on the client (e.g. account page locked)
   *   - be blocked from performing any subscription-altering mutations on the server (i.e. all such mutations should return early with an error)
   *
   * For users with subscriptions marked as fully migrated, no actions should be blocked, regardless of this flag
   */
  MIGRATION_ACCOUNT_LOCK: 'migration_account_lock',

  /**
   * ADYEN
   *
   * When enabled, use Adyen iframe instead of Zuora iframe for checkout and update payment method forms
   */
  ADYEN: 'adyen',

  /**
   * ADYEN_PAYPAL
   *
   * When enabled, Adyen iframe should offer PayPal as a payment method in co-operating countries
   */
  ADYEN_PAYPAL: 'adyen_paypal',

  /* STRIPE_ACCESS_FIX
   *
   * When enabled, Stripe gateway subscriptions should no longer grant access
   */
  STRIPE_ACCESS_FIX: 'stripe_access_fix',

  /**
   * ENTITLEMENTS
   *
   * When enabled, use the Brooklyn user JWT to determine access for Gaia gateway subscriptions
   */
  ENTITLEMENTS: 'entitlements',

  /**
   * BRIGHTCOVE
   */
  BRIGHTCOVE_MEDIA_SOURCE: 'brightcove_media_source', // affects MOBILE and TV

  /**
   * CHECKOUT_V2
   *
   * Web only.
   * When enabled, use Brooklyn's /v2 checkout API instead of /v1
   */
  CHECKOUT_V2: 'checkout_v2',

  SITE_WIDE_SEARCH: 'site_wide_search',

  /**
   * BRIGHTCOVE_TEST_PLAYER
   *
   * WEB ONLY. Enable test player.
   * The main use-case is testing new version of BC player
   */
  BRIGHTCOVE_TEST_PLAYER: 'brightcove_test_player',

  /**
   * BRIGHTCOVE_HLS_BYTERANGE
   * ALL PLATFORMS
   * enable request for the new HLS byte range format
   */
  BRIGHTCOVE_HLS_BYTERANGE: 'brightcove_hls_byterange',

  /**
   * SALES_BANNER
   * ALL PLATFORMS
   * show sales banner
   */
  SALES_BANNER: 'sales_banner',

  /**
   * REDIRECT_TO_CHANGE_PLAN
   * WEB ONLY
   * Redirect users from `create-account` page with active membership to special
   * change plan page, if supported SKU.
   */
  REDIRECT_TO_CHANGE_PLAN: 'redirect_to_change_plan',

  /**
   * BLACK_FRIDAY
   * web:
   *   - show black friday banner
   *   - show ribbon on course cards for sale
   */
  BLACK_FRIDAY: `black_friday` as const,

  /**
   * NEW_YEAR_BANNER
   * web:
   *   - show new year banner
   */
  NEW_YEAR_BANNER: `new_year_banner` as const,

  /**
   * NEW_YEAR_BANNER
   * web:
   *   - show new year 3 month banner. It  has higher priority than NEW_YEAR_BANNER
   */
  NEW_YEAR_3_MONTH_BANNER: `new_year_3_month_banner` as const,

  /**
   * MEMBERSHIP_PAGE_SALES_CARD
   * web:
   *   - show black friday banner
   *   - show ribbon on course cards for sale
   */
  MEMBERSHIP_PAGE_SALES_CARD: `membership_page_sales_card` as const,

  /**
   * SALES_BANNER
   * WEB only
   * show sales banner
   */
  WEB_SALES_BANNER: 'web_sales_banner',
} as const);

export const SUBSCRIPTION_GATEWAYS = Object.freeze({
  GAIA: 'Gaia',
  IOS: 'ios',
  ANDROID: 'android',
  APPLE_TV: 'Apple TV',
  FIRE_TV: 'Fire TV',
  STRIPE: 'Stripe',
  ROKU: 'Roku',
  PAYPAL: 'PayPal',
});
